// extracted by mini-css-extract-plugin
module.exports = {"text":"TitledLabel__text___3-w6L","large":"TitledLabel__large___1uQQk"};